import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Panel } from 'primereact/panel';
import renderValue from './DynamicDataRenderer'; // Import the helper

interface VersionCompareData {
    [key: string]: {
        old: any;
        new: any;
    };
}

interface VersionCompareTableProps {
    data: VersionCompareData;
}

const VersionCompareTable: React.FC<VersionCompareTableProps> = ({ data }) => {
    const [transformedData, setTransformedData] = useState<any[]>([]);

    useEffect(() => {
        if (data && typeof data === 'object') {
            const processedData = Object.entries(data).map(([field, values]) => {
                return {
                    field: field,
                    oldValue: values.old,
                    newValue: values.new,
                };
            });
            setTransformedData(processedData);
        } else {
            setTransformedData([]);
        }
    }, [data]);

    const fieldBodyTemplate = (rowData: any) => {
        return <span style={{ fontWeight: 'bold' }}>{rowData.field}</span>;
    };

    const oldValueBodyTemplate = (rowData: any) => {
        // Pass fieldName and 'old' to help renderValue make decisions if needed
        return renderValue(rowData.oldValue, rowData.field, 'old');
    };

    const newValueBodyTemplate = (rowData: any) => {
        // Pass fieldName and 'new'
        return renderValue(rowData.newValue, rowData.field, 'new');
    };

    if (!transformedData.length) {
        return <p>No data to display.</p>;
    }

    return (
        <Panel header="Version Compare Details">
            <DataTable value={transformedData} responsiveLayout="scroll" stripedRows>
                <Column
                    field="field"
                    header="Field"
                    body={fieldBodyTemplate}
                    style={{ width: '10%', verticalAlign: 'top' }}
                />
                <Column
                    header="Old Value"
                    body={oldValueBodyTemplate}
                    style={{ width: '45%', verticalAlign: 'top' }}
                />
                <Column
                    header="New Value"
                    body={newValueBodyTemplate}
                    style={{ width: '45%', verticalAlign: 'top' }}
                />
            </DataTable>
        </Panel>
    );
};

export default VersionCompareTable;